let fieldConfig = {
    version: 1.7,
    profileType: '45',
    queryForm: [
        {
            label: '公司名称',
            selected: true,
            default: true,
            name: 'orgName',
        },
        {
            label: '纳税人识别号',
            selected: true,
            default: true,
            name: 'taxCode',
        },
        {
            label: '开票介质',
            selected: true,
            default: true,
            name: 'diskType',
            dict: 'ovat_disk_type',
            type: 'dict',
        },
        {
            label: '发票种类',
            selected: true,
            default: true,
            name: 'invoiceType',
            dict: 'inv_type',
            type: 'dict',
        },
        {
            label: '开票点',
            selected: true,
            default: true,
            name: 'ukeyCode',
        },
        {
            label: '开票方式',
            selected: true,
            default: true,
            name: 'manageType',
            dict: 'manage_type',
            type: 'dict',
        },
        {
            label: '所属区域',
            selected: true,
            default: true,
            name: 'regionName',
            type: 'regionName',
        },
        {
            label: '主管税局所在省（市）',
            selected: true,
            default: true,
            name: 'province',
            type: 'province',
        },
    ],
    table: [
        {
            label: '公司名称',
            selected: true,
            default: true,
            name: 'orgName',
            sort: false,
        },
        {
            label: '纳税人识别号',
            selected: true,
            default: true,
            name: 'taxCode',
            sort: false,
        },
        {
            label: '开票介质',
            selected: true,
            default: true,
            name: 'diskType',
            dict: 'ovat_disk_type',
            type: 'dict',
            sort: false,
        },
        {
            label: '发票种类',
            selected: true,
            default: true,
            name: 'invoiceType',
            dict: 'inv_type',
            type: 'dict',
            sort: false,
        },
        {
            label: '开票点编号',
            selected: true,
            default: true,
            name: 'ukeyCode',
            sort: false,
        },
        {
            label: '开票方式',
            selected: true,
            default: true,
            name: 'manageType',
            dict: 'manage_type',
            type: 'dict',
            sort: false,
        },
        {
            label: '购票状态',
            selected: true,
            default: true,
            name: 'buyStatus',
            dict: 'receipt_type',
            sort: false,
        },
        {
            label: '领票状态',
            selected: true,
            default: true,
            name: 'ticketStatus',
            sort: false,
        },
        {
            label: '库存余量',
            selected: true,
            default: true,
            name: 'remain',
            sort: false,
        },
        {
            label: '购票员',
            selected: true,
            default: true,
            name: 'operatorName',
            sort: false,
        },
        {
            label: '购票日期',
            selected: true,
            default: true,
            name: 'dealDate',
            type: 'date',
            sort: false,
        },
        {
            label: '失败原因',
            selected: true,
            default: true,
            name: 'remark',
            sort: false,
        },
        {
            label: '所属区域',
            selected: true,
            default: true,
            name: 'regionName',
            sort: false,
        },
        {
            label: '主管税局所在省（市）',
            selected: true,
            default: true,
            name: 'province',
            sort: false,
        },
    ],
}

export default fieldConfig



// WEBPACK FOOTER //
// ./src/app/outputManage/stock/InventoryQuery/fieldConfig.js